
import { Box } from "@mui/material";
import DecisioningMain from "../../components/Application/Decisioning/DecisioningMain";
import MainLayout from 'layouts/mainLayout'

const decisioningData = [
  {
    "label": "Firmographic",
    "items": [
      {
        "checkboxKey": "isYearsInBusinessChecked",
        "label": "Minimum Years in Business",
        "tooltipContent": "Years in Business = Current year - year the business was established",
        "isError": false,
        "slider": {
          "min": 0,
          "max": 5,
          "step": 1,
          "marks": [
            { "value": 0, "label": "0" },
            { "value": 1, "label": "1" },
            { "value": 2, "label": "2" },
            { "value": 3, "label": "3" },
            { "value": 4, "label": "4" },
            { "value": 5, "label": "5+" }
          ],
          "valueKey": "yearsInBusinessLowerLimit",
          "valueLabelFormat": {
            "append": " or more"
          },
          "track": "inverted"
        }
      },
      {
        "checkboxKey": "isActiveBusinessIndicatorChecked",
        "label": "Include Active Businesses Only",
        "tooltipContent": "This field indicates if the business is in the market or is out of business now.",
        "isError": false
      },
      {
        "checkboxKey": "isAnnualSalesVolumeChecked",
        "label": "Annual Sales Volume Threshold",
        "tooltipContent": "Yearly Sales Volume",
        "isError": false,
        "slider": {
          "min": 0,
          "max": 190,
          "step": null,
          "scale": "currency",
          "valueLabelFormat": {
            "formatter": "currency"
          },
          "marks": [
            { "value": 0, "label": "$0", "scaledValue": 0 },
            { "value": 10, "scaledValue": 10000 },
            { "value": 20, "scaledValue": 20000 },
            { "value": 30, "scaledValue": 30000 },
            { "value": 40, "scaledValue": 40000 },
            { "value": 50, "label": "$50K", "scaledValue": 50000 },
            { "value": 60, "scaledValue": 60000 },
            { "value": 70, "scaledValue": 70000 },
            { "value": 80, "scaledValue": 80000 },
            { "value": 90, "scaledValue": 90000 },
            { "value": 100, "label": "$100K", "scaledValue": 100000 },
            { "value": 110, "scaledValue": 200000 },
            { "value": 120, "scaledValue": 300000 },
            { "value": 130, "scaledValue": 400000 },
            { "value": 140, "label": "$500K", "scaledValue": 500000 },
            { "value": 150, "scaledValue": 600000 },
            { "value": 160, "scaledValue": 700000 },
            { "value": 170, "scaledValue": 800000 },
            { "value": 180, "scaledValue": 900000 },
            { "value": 190, "label": "$1M+", "scaledValue": 1000000 }
          ],
          "valueKey": "annualSalesVolumeLowerLimit",
          "track": "inverted"
        }
      },
      {
        "checkboxKey": "isNumberOfEmployeesChecked",
        "label": "Minimum Number of Employees",
        "tooltipContent": "Number of Employees with the Company",
        "isError": false,
        "slider": {
          "min": 1,
          "max": 50,
          "step": null,
          "marks": [
            { "value": 1, "label": "1" },
            { "value": 2 },
            { "value": 3 },
            { "value": 4 },
            { "value": 5 },
            { "value": 6 },
            { "value": 7 },
            { "value": 8 },
            { "value": 9 },
            { "value": 10, "label": "10" },
            { "value": 20, "label": "20" },
            { "value": 30, "label": "30" },
            { "value": 40, "label": "40" },
            { "value": 50, "label": "50+" }
          ],
          "valueLabelFormat": {
            "append": " or more"
          },
          "valueKey": "numberOfEmployeesLowerLimit",
          "track": "inverted"
        }
      }
    ]
  },
  {
    "label": "Business Health",
    "items": [
      {
        "checkboxKey": "isBusinessFailureScoreChecked",
        "label": "Markaaz Failure Risk Score Threshold",
        "options": ["Less than 6", "Less than 9"],
        "tooltipContent": "The Business Failure Risk Scoring System is designed to predict the likelihood of a business ceasing operations with a loss to creditors within a 12‐month period. Businesses are assigned a risk rating ranging from 1 to 9, with a zero indicating bankruptcy. A high rating indicates a high likelihood of business failure, and a low rating indicates lower chances of business failure",
        "isError": false,
        "slider": {
          "min": -9,
          "max": -1,
          "marks": [
            { "value": -1, "label": "1" },
            { "value": -2, "label": "2" },
            { "value": -3, "label": "3" },
            { "value": -4, "label": "4" },
            { "value": -5, "label": "5" },
            { "value": -6, "label": "6" },
            { "value": -7, "label": "7" },
            { "value": -8, "label": "8" },
            { "value": -9, "label": "9" }
          ],
          "valueLabelFormat": {
            "formatter": "riskScoreRange"
          },
          "scale": "reverse",
          "valueKey": "businessFailureScoreLowerLimit",
          "track": "inverted",
          "sx": "risk"
        }
      },
      {
        "checkboxKey": "isBusinessCreditRiskScoreChecked",
        "label": "Markaaz Credit Risk Score Threshold",
        "tooltipContent": "The Business Credit Risk score measures the risk of a business becoming severely delinquent within a 12-month period. Businesses are assigned a value ranging from 103 to 600, with high values indicating lower chances of severe delinquency. A score of zero indicates bankruptcy on file. Values which are greater than 500 are considered to be good values for credit risk score",

        "slider": {
          "min": 103,
          "max": 600,
          "valueKey": "businessCreditRiskScoreLowerLimit",
          "marks": [
            { "value": 103, "label": "103" },
            { "value": 200, "label": "200" },
            { "value": 300, "label": "300" },
            { "value": 400, "label": "400" },
            { "value": 500, "label": "500" },
            { "value": 600, "label": "600" }
          ],
          "valueLabelFormat": {
            "append": " or higher"
          },
          "track": "inverted",
          "sx": "risk"
        },
        "isError": false
      },
      {
        "checkboxKey": "isGlobalCreditRiskScoreChecked",
        "label": "Markaaz Global Credit Risk Score",
        "tooltipContent": "This is the global data normalization of a credit risk score",
        "slider": {
          "min": 1,
          "max": 5,
          "step": 1,
          "marks": [
            { "value": 1, "label": "1" },
            { "value": 2, "label": "2" },
            { "value": 3, "label": "3" },
            { "value": 4, "label": "4" },
            { "value": 5, "label": "5" }
          ],
          "valueKey": "globalCreditRiskScoreLowerLimit",
          "valueLabelFormat": {
            "formatter": "globalCreditFormat"
          },
          "track": "inverted",
          "sx": "risk"
        },
        "isError": false
      },
      {
        "checkboxKey": "excludeBankruptBusinesses",
        "label": "Exclude Bankrupt Businesses",
        "tooltipContent": "Bankruptcy Indicator - Indicates that a business has had a bankruptcy in their current or past history",
        "isError": false
      }
    ]
  },
  {
    "label": "Compliance",
    "items": [
      {
        "checkboxKey": "excludeBusinessesWithActiveSanctions",
        "label": "Exclude Businesses with Active Sanctions",
        "tooltipContent": "Sanctions are restrictive measures imposed by an international body, multilateral agency, or a national government on a regime, organisation, or individual.It is by either European Union, the United Nations, the United States Office of Foreign Assets Control and State Department and Her Majesty’s Treasury in the United Kingdom"
      },
      {
        "checkboxKey": "excludeBusinessesWithActivePep",
        "label": "Exclude Businesses with Active Politically Exposed Persons",
        "tooltipContent": "PEP is Any individual that is considered a Politically Exposed Person, from Head of State to Members of Parliament, Members of the Board of State Owned Enterprises or Ambassadors and individuals representing their countries interests abroad."
      },
      {
        "checkboxKey": "excludeBusinessesWithActiveAdverseMedia",
        "label": "Exclude Businesses with Active Adverse Media",
        "tooltipContent": "Any individual or entity that has been reported in global newspapers, news sites or other media as being involved in financial crime",
        "slider": {
          "min": 1,
          "max": 10,
          "valueKey": "activeAdverseMediaLowerLimit",
          "marks": [
            { "value": 1, "label": "1" },
            { "value": 2, "label": "2" },
            { "value": 3, "label": "3" },
            { "value": 4, "label": "4" },
            { "value": 5, "label": "5" },
            { "value": 6, "label": "6" },
            { "value": 7, "label": "7" },
            { "value": 8, "label": "8" },
            { "value": 9, "label": "9" },
            { "value": 10, "label": "10+" }
          ],
          "valueLabelFormat": {
            "append": " count or more"
          },
          "track": "inverted"
        }
      },
      {
        "checkboxKey": "excludeBusinessesWithActiveInsolvencyReport",
        "label": "Exclude Businesses with Active Insolvency Report",
        "tooltipContent": "Any individual that has been declared as bankrupt or insolvent"
      },
      {
        "checkboxKey": "excludeBusinessesWithActiveLawEnforcement",
        "label": "Exclude Businesses with Active Law Enforcement",
        "tooltipContent": "Entity or Principals that has been named in official documentation from Law Enforcement bodies such as the Police or any other agency such as Interpol or the FBI. Also those individuals and entities cited in Court and legal documents of that nature."
      }
    ]
  }
]


const DecisioningPage = () => {

  const decisioningValues = {
    "epId": 1,
    "matchConfidenceScoreLowerLimit": 2.9,
    "yearsInBusinessLowerLimit": 2,
    "isActiveBusinessIndicatorChecked": true,
    "annualSalesVolumeLowerLimit": 500000,
    "numberOfEmployeesLowerLimit": 20,
    "businessFailureScoreLowerLimit": 3,
    "businessCreditRiskScoreLowerLimit": 393,
    "excludeBankruptBusinesses": true,
    "isMatchConfidenceScoreChecked": true,
    "isYearsInBusinessChecked": true,
    "isAnnualSalesVolumeChecked": true,
    "isNumberOfEmployeesChecked": true,
    "isBusinessFailureScoreChecked": true,
    "isBusinessCreditRiskScoreChecked": true,
    "excludeBusinessesWithActiveSanctions": true,
    "excludeBusinessesWithActivePep": true,
    "activeAdverseMediaLowerLimit": 6,
    "excludeBusinessesWithActiveAdverseMedia": true,
    "excludeBusinessesWithActiveInsolvencyReport": true,
    "excludeBusinessesWithActiveLawEnforcement": true,
    "excludeShareholderOtherCountry": true,
    "excludeShareholderAmountsUndisclosed": true,
    "excludeActiveLegalFilings": false,
    "activeLegalFilingsLimit": null,
    "approvedOn": "2025-03-11T08:09:16.141191Z",
    "approvalStatus": "A",
    "isGlobalCreditRiskScoreChecked": true,
    "globalCreditRiskScoreLowerLimit": 2,
    "businessDebtRatioLowerLimit": 30,
    "businessDebtRatioUpperLimit": 60,
    "businessDebtRatioEnabled": false,
    "businessLiquidityRatioLowerLimit": 1.5,
    "businessLiquidityRatioUpperLimit": 2,
    "businessLiquidityRatioEnabled": false,
    "businessEquityPercentageRatioLowerLimit": 50,
    "businessEquityPercentageRatioUpperLimit": 70,
    "businessEquityPercentageRatioEnabled": false
  }

  return (
    <Box>
      <MainLayout>
        <DecisioningMain
          values={decisioningValues}
          data={decisioningData}
          submitInProgress={false}
          showDecisionNotification={false}
          onRadioChange={() => { }}
          onCheckboxChange={() => { }}
          onSliderChange={() => { }}
          onSubmit={() => { }}
          onReset={() => { }}
          onAlertClose={() => { }}
          isPartnerChanged={false}
        />
      </MainLayout>
    </Box>
  );
};

export default DecisioningPage;
